import React from 'react'
import { Modal } from 'react-bootstrap'
import { NavLink } from 'react-router-dom';

const AttendancePopup = ({
  title = "Attendance Alert",
  onClose = () => { },
  date = null,
}) => {


  const updatedDate = (date || new Date()).toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });


  return (
    <Modal show={true} animation={true} size="md" aria-labelledby="example-modal-sizes-title-sm" className='department-modal ' centered>
      <Modal.Body>
        <div className="grid-margin stretch-card inner-pages mb-lg-0 position-relative">
          <p className='attendance-popup-close' onClick={onClose}><i className="fa-solid fa-xmark"></i></p>
          <div className="card">
            <div className="card-body">
              <div className="text-center mb-4">
                <div className="attendance-icon-wrapper">
                  <svg
                    className="attendance-clock-icon"
                    width="64"
                    height="64"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </div>
              </div>
              <h2 className="text-center mb-3 font-weight-bold attendance-title">
                {title}
              </h2>

              {/* Message */}
              <p className="text-center text-muted mb-4 attendance-message">
                You haven't punched in or punched out on
                <strong> {updatedDate}</strong>.
                <br />
                Please update your attendance to add your report.
              </p>
              <div className='d-flex justify-content-center'>
                <NavLink to="/attendance" type="button" className="btn btn-gradient-primary mr-2">Go to Attendance Page</NavLink>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default AttendancePopup